var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRheinbahnRocket(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "358px",
    height: "358px",
    viewBox: "0 0 285 610",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "-4.4408921e-15 0 283.464529 0 283.464529 610.783 -4.4408921e-15 610.783"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-10"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-2"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-1",
    fill: "currentColor",
    mask: "url(#mask-2)",
    points: "61.9561069 464.694 217.575107 464.694 217.575107 179.136 61.9561069 179.136"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.9511069,179.894 C63.6331069,114.322 86.2141069,56.988 130.304107,8.13 C140.025107,-2.65 140.264107,-2.717 149.799107,7.972 C193.518107,56.948 217.186107,113.819 217.742107,179.722",
    id: "Fill-3",
    fill: "currentColor",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.830107,219.83 C161.140107,219.83 178.424107,202.547 178.424107,181.237 C178.424107,159.927 161.140107,142.643 139.830107,142.643 C118.521107,142.643 101.237107,159.927 101.237107,181.237 C101.237107,202.547 118.521107,219.83 139.830107,219.83",
    id: "Fill-4",
    fill: "#FFFFFE",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.6941069,514.982 C97.6941069,550.211 128.580107,593.175 142.579107,610.843 C156.591107,593.175 187.476107,550.211 187.476107,514.982 C187.476107,499.764 185.119107,487.354 180.510107,477.858 L104.661107,477.858 C100.052107,487.354 97.6941069,499.764 97.6941069,514.982",
    id: "Fill-5",
    fill: "currentColor",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.7091069,255.766 C68.7091069,255.766 6.5411069,310.57 1.1111069,372.235 C-4.3188931,433.9 11.9181069,516.119 11.9181069,516.119 L72.7621069,447.607 L68.7091069,255.766",
    id: "Fill-6",
    fill: "currentColor",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.7091069,255.766 C68.7091069,255.766 6.5411069,310.57 1.1111069,372.235 C-4.3188931,433.9 11.9181069,516.119 11.9181069,516.119 L72.7621069,447.607 L68.7091069,255.766 Z",
    id: "Stroke-7",
    stroke: "currentColor",
    strokeWidth: 0.306,
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.755107,255.766 C214.755107,255.766 276.923107,310.57 282.353107,372.235 C287.784107,433.9 271.546107,516.119 271.546107,516.119 L210.703107,447.607 L214.755107,255.766",
    id: "Fill-8",
    fill: "currentColor",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.755107,255.766 C214.755107,255.766 276.923107,310.57 282.353107,372.235 C287.784107,433.9 271.546107,516.119 271.546107,516.119 L210.703107,447.607 L214.755107,255.766 Z",
    id: "Stroke-9",
    stroke: "currentColor",
    strokeWidth: 0.306,
    mask: "url(#mask-2)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M56.4861069,256.209 L56.4861069,489.571 M223.041107,254.632 L223.041107,489.57",
    id: "Stroke-11",
    stroke: "#FFFFFE",
    strokeWidth: 10.5
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRheinbahnRocket);
export default __webpack_public_path__ + "static/media/rheinbahn-rocket.98c62b4995fcc07b986fb4863c710c1e.svg";
export { ForwardRef as ReactComponent };